<ng-template [ngTemplateOutlet]="templateElement"></ng-template>

<ng-template #typ00>
  <ng-template [ngTemplateOutlet]="common"></ng-template>
</ng-template>

<ng-template #typ01>
  <cap-link
    [enableNavigation]="enableNavigation"
    [histinfo]="histInfo"
    [queryParams]="getQueryParams(version)"
    [target]="navTargets.NAV_RECHT"
    [tooltipParams]="{ art: rechtArt | translate }">
    <ng-container
      >{{ (formatMatches(["STANDARDRECHT_TYP01", "STANDARDRECHT_TYP02"]) ? getAbkuerzungKey(rechtArt) : rechtArt) | translate }}
    </ng-container>
    <ng-container> {{ recht.rechteId | formatRechteId }}</ng-container>
  </cap-link>
  <ng-template [ngTemplateOutlet]="common"></ng-template>
</ng-template>

<ng-template #common>
  <cap-read-more
    [capHistinfo]="histInfo"
    [limit]="textLimit"
    [queryParams]="getQueryParams(version)"
    [target]="navTargets.NAV_RECHT"
    [text]="text"
    [textIsLink]="enableNavigation"
    [tooltipDetail]="{ art: rechtArt | translate }">
  </cap-read-more>
</ng-template>
